<template>
    <!-- The settings frame. It paints NOTHING: the canvas belongs to the body
         rule in theme/theme.css, so the section's cards stand on it as panels
         (views/settings/components/SettingsSection.vue) instead of every surface
         being one flat sheet.

         It is not the house `templates/shell/Default.vue` and deliberately so
         (tech spec §12): Jackdaw's signed-in shell is the mail client's own
         three-pane layout, and settings is the master-detail that opens out of
         it — the left nav is SettingsNav, rendered by views/settings/Settings.vue
         where the section's own routes are.

         The gutter is reserved whether or not this scrolls: settings pages of
         different heights toggled the scrollbar on and off, and the width it
         took changed the layout under them on every tab switch. It is on this
         element rather than on the document because the document never scrolls —
         the frame is the dynamic viewport's height and this is the one box with
         overflow.

         The house content column carries a child-shrink guard — the arbitrary
         variant that hangs `shrink-0` on every direct child (vue-spec theme.md,
         the shell contract; spelled out there, not here, because Tailwind reads
         comments too and would emit the rule for a class this file never uses).
         This one does NOT carry it, deliberately. That guard exists because the
         house `main` is a flex COLUMN: a page root is a flex item of it, and an
         item that clips (`AppCard`, a table) gets squeezed to the frame and
         swallows its own last rows. This `main` is a block — it is
         a flex item of the frame beside it, not a flex container itself — so a
         page root's height is its content's and nothing can squeeze it; the
         class would have no box to act on. Making it a column to earn the class
         is the trade the other way: the section below centres on `mx-auto`
         inside `max-w-5xl`, and auto margins in a column's cross axis drop it to
         shrink-to-fit — measured at 1280px, 1024px of settings became 561-684px.
         A page that wants an internal scroll area of its own still opts in the
         house way, with `h-full min-h-0` on its root. -->
    <div class="flex h-dvh">
        <main class="flex-1 overflow-auto p-4 lg:p-6 [scrollbar-gutter:stable]">
            <slot />
        </main>
    </div>
</template>
